import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { Helper } from '../../../../utils/helper';
import { CommonModule } from '@angular/common';

import { ReactiveFormsModule } from '@angular/forms';

import { BlockTextComponent } from '../../common/block-text/block-text.component';
import {
  RcsInitModel,
  RcsInitVariables,
  RcsModel,
  RcsVariables,
} from '../../../../models/rcs-template/rcs.interface';
import { NotificationComponent } from '../../common/notification/notification.component';
import { PinComponent } from '../../common/pin/pin.component';
import { BaseComponent } from '../../common/BaseComponent';
import { VariableMaxLengthService } from '../../../../services/variable-max-length.service';

@Component({
    selector: 'app-rcs',
    imports: [
        CommonModule,
        ReactiveFormsModule,
        BlockTextComponent,
        NotificationComponent,
        PinComponent,
    ],
    templateUrl: './rcs.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './rcs.component.scss'
})
export class RcsComponent extends BaseComponent implements OnInit {
  @Input() block: RcsModel = new RcsInitModel();
  @Input() isPreview = false;
  @Output() blockData = new EventEmitter<any>();
  @Output() removeBlockEvent = new EventEmitter<string | null>();

  count: number = 0;
  currentTime: string = new Date().toISOString().slice(11, 16);

  ngOnInit() {
    if (Helper.isEmpty(this.block.variables!)) {
      this.block.variables = new RcsInitVariables()
    }
  }

  //placeholders:
  textPlaceHolder = "Enter text";
  imageUrlPlaceHolder = "Enter image URL";
  ctaTextPlaceHolder = "Enter CTA button text";
  ctaLinkPlaceHolder = "Enter CTA link";

  removeBlock(): void {
    this.removeBlockEvent.emit(this.block.blockId);
  }

  onChange(value: any, fieldName: keyof RcsVariables) {
    if (this.block.variables) {
      this.block.variables[fieldName] = value;
      this.blockData.emit(this.block);
    }
  }

  onContainerClick(event: MouseEvent) {
    // Forward the click event to the child app-pin component
    this.pinComponent.onContainerClick(event);
  }
}
